import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@loot-os/ui/components/card";
import { useQuery } from "@tanstack/react-query";

import { useTRPC } from "../lib/trpc";
import { EnvironmentEventsUrls } from "./EnvironmentEventsUrls";

/**
 * Platform-only: where Loot OS POSTs each environment's order events and box events, live and
 * sandbox alike. Each request is signed with a secret derived for the environment; staff hand it
 * over from `packages/scripts/src/fulfillment/order-events-secret.ts`.
 */
export function TenantEventsCard({ tenantId, archived }: { tenantId: string; archived: boolean }) {
  const trpc = useTRPC();
  const envs = useQuery(trpc.environments.list.queryOptions());

  return (
    <Card>
      <CardHeader>
        <CardTitle>Order and box events</CardTitle>
        <CardDescription>
          Platform staff only. Order events: sent when Loot OS changes one of the environment's
          orders itself (a staff cancel, a vendor shipment, a bot purchase), so the tenant can tell
          its own users; changes the tenant makes through the Fulfillment API are not sent back. Box
          events: sent when one of the environment's boxes, or a template it has enabled, changes (a
          new version, stock, status). Empty sends none.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        {envs.error && <p className="text-sm text-destructive">{envs.error.message}</p>}
        {envs.data?.map((env) => (
          <EnvironmentEventsUrls
            key={env.id}
            tenantId={tenantId}
            environment={env}
            archived={archived}
          />
        ))}
      </CardContent>
    </Card>
  );
}
